import { useCallback } from "react";

import type { PlanStock_StockManagementQuery } from "@/lib/gql/__generated__/graphql";

import { useTransitionBlock } from "@/hooks/use-transition-block";

import {
	FeatureIslandContainer,
	FeatureIslandHeader,
	FeatureIslandMainWithBackGround,
} from "@/components/features/_layouts";
import { useIsSideMenuMobileRendered } from "@/components/features/side-menu/mobile";

import { HeaderUpdateButton, PlanStockManagementForLaptop, PlanStockManagementForMobile } from "./components";
import { useInitialized } from "../model/init";

// eslint-disable-next-line import/no-restricted-paths
import type { ApolloQueryResult } from "@apollo/client";

type Props = {
	hotelID: string;

	startDt: string;
	endDt: string;
	todaysDt: string;

	serverModel: PlanStock_StockManagementQuery;
	onFetchPlanStock: ({
		input: { startDt, endDt },
	}: {
		input: {
			startDt: string;
			endDt: string;
		};
	}) => Promise<ApolloQueryResult<PlanStock_StockManagementQuery | undefined>>;
};

export const PlanStockManagementPresenter = ({
	hotelID: _hotelID,
	startDt,
	todaysDt,
	serverModel: _serverModel,
	onFetchPlanStock,
}: Props) => {
	const { serverModel, planStockDiffStore, onUpdatePlanStock, isValid, isDirty, onRefetch } = useInitialized({
		serverModel: _serverModel,
		onFetchPlanStock,
	});

	const handleOnSelectYearOrMonth = useCallback(
		async (input: { startDt: string; endDt: string }) => {
			await onRefetch(input);
		},
		[onRefetch],
	);

	const isSideMenuMobileRendered = useIsSideMenuMobileRendered();

	useTransitionBlock(isDirty);

	return (
		<FeatureIslandContainer>
			<FeatureIslandHeader
				title="プラン在庫の設定"
				rightChildren={
					<HeaderUpdateButton isValid={isValid} isDirty={isDirty} onUpdatePlanStock={onUpdatePlanStock} />
				}
			/>

			<FeatureIslandMainWithBackGround>
				{isSideMenuMobileRendered ? (
					<PlanStockManagementForMobile
						todaysDt={todaysDt}
						startDt={startDt}
						serverModel={serverModel}
						handleOnSelectYearOrMonth={handleOnSelectYearOrMonth}
						planStockDiffStore={planStockDiffStore}
					/>
				) : (
					<PlanStockManagementForLaptop
						todaysDt={todaysDt}
						serverModel={serverModel}
						handleOnSelectYearOrMonth={handleOnSelectYearOrMonth}
						planStockDiffStore={planStockDiffStore}
					/>
				)}
			</FeatureIslandMainWithBackGround>
		</FeatureIslandContainer>
	);
};

PlanStockManagementPresenter.displayName = "PlanStockManagementPresenter";
